import { render, staticRenderFns } from "./ChooseExamine.vue?vue&type=template&id=70e10dac&scoped=true"
import script from "./ChooseExamine.vue?vue&type=script&lang=js"
export * from "./ChooseExamine.vue?vue&type=script&lang=js"
import style0 from "./ChooseExamine.vue?vue&type=style&index=0&id=70e10dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e10dac",
  null
  
)

export default component.exports